import { checkObjectType } from "../../modules/dashboard/CardChildrenSelector";
import { SunburstChartProps } from "../../modules/dashboard/components/SunBurstChart";
import { EvolutionChartProps } from "../../modules/dashboard/components/EvolutionChart";
import { TextCardContentProps } from "../../modules/dashboard/components/TextCardContent";
import { WeatherInfoCardContentProps } from "../../modules/dashboard/components/WeatherInfoCardContent";
import { AccumulatedCertifiedEnergyProps } from "../../modules/dashboard/components/metas/AccumulatedCertifiedEnergyChart";
import { AccumulatedEnergyProps } from "../../modules/dashboard/components/metas/AccumulatedEnergyChart";
import { LossDiagramProps } from "../../modules/dashboard/components/metas/LossDiagramChart";
import { ProductivityProps } from "../../modules/dashboard/components/metas/ProductivityChart";
import {
  CardChildrenProps,
  CardInfo,
  CardInfoIdentifiers,
  CardTypesEnum,
  CardsDisplayableProps,
  ChildrenTypeEnum,
  ItemLayoutsConfig,
} from "../../modules/dashboard/types";
import {
  defaultLayoutPRRealizado,
  defaultLayoutPerformanceRatio,
  defaultLayoutEnergiaGerada,
  defaultLayoutValorGerado,
  defaultLayoutDisponibilidade,
  defaultLayoutAmbiente,
  defaultLayoutEvolucaoGeracao,
  defaultLayoutGeracaoPlanta,
  defaultLayoutEnergiaAcumulada,
  defaultLayoutDiagramaPerdas,
  defaultLayoutEnergiaAcumEnergiaCert,
  defaultLayoutProdutividade,
  accumulatedCertifiedEnergyProps,
  accumulatedEnergyProps,
  disponibilidadeContentProps,
  sunburstChartProps,
  energiaGeradaContentProps,
  evolutionChartProps,
  lossDiagramProps,
  performanceRatioContentProps,
  prRealizadoContentProps,
  productivityProps,
  valorGeradoContentProps,
  weatherInfoProps,
  prRealizadoCardId,
  performanceRatioCardId,
  energiaGeradaCardId,
  valorGeradoCardId,
  disponibilidadeCardId,
  wheaterCardId,
  evolutionChartCardId,
  sunburstCardId,
  accumulatedEnergyCardId,
  lossDiagramCardId,
  accumulatedCertifiedEnergyCardId,
  productivityCardId,
  defaultLayoutPareto,
  paretoChartProps,
  paretoChartCardId,
  defaultLayoutTensaoDeLinha,
  tensaoDeLinhaContentProps,
  TensaoDeLinhaCardId,
  defaultLayoutTracker,
  trackerChartProps,
  trackerChartCardId,
  defaultLayoutHeatmap,
  heatmapChartProps,
  heatmapChartCardId,
  potenciaAtivaContentProps,
  defaultLayoutPotenciaAtiva,
  potenciaAtivaCardId,
  defaultLayoutEnergiaAcumuladaMWh,
  energiaAcumuladaMWhContentProps,
  energiaAcumuladaMWhCardId,
  defaultLayouts,
} from "./defaultLayoutData";
import { filterTrackerFromCardsConfig, filterTrackerFromLayouts } from "../../modules/dashboard/helpers/trackerCardVisibility";
import { ParetoChartProps } from "../../modules/dashboard/components/ParetoChart";
import { TrackerChartProps } from "../../modules/dashboard/components/TrackerChart";
import { HeatmapChartProps } from "../../modules/dashboard/components/HeatmapChart";
export function getChildrenTypeByCardEnum(type: CardTypesEnum) {
  switch (type) {
    case CardTypesEnum.PRRealizado:
      return ChildrenTypeEnum.TextCard;

    case CardTypesEnum.PerformanceRatio:
      return ChildrenTypeEnum.TextCard;

    case CardTypesEnum.EnergiaGerada:
      return ChildrenTypeEnum.TextCard;

    case CardTypesEnum.ValorGerado:
      return ChildrenTypeEnum.TextCard;

    case CardTypesEnum.Disponibilidade:
      return ChildrenTypeEnum.TextCard;

    case CardTypesEnum.Ambiente:
      return ChildrenTypeEnum.WeatherCard;

    case CardTypesEnum.EvolucaoGeracao:
      return ChildrenTypeEnum.EvolutionChart;

    case CardTypesEnum.GeracaoPlanta:
      return ChildrenTypeEnum.SunburstChart;

    case CardTypesEnum.EnergiaAcumulada:
      return ChildrenTypeEnum.AccumulatedEnergyChart;

    case CardTypesEnum.DiagramaPerdas:
      return ChildrenTypeEnum.LossDiagramChart;

    case CardTypesEnum.EnergiaAcumEnergiaCert:
      return ChildrenTypeEnum.AccumulatedCertifiedEnergyChart;

    case CardTypesEnum.Produtividade:
      return ChildrenTypeEnum.ProductivityChart;

    case CardTypesEnum.Pareto:
      return ChildrenTypeEnum.ParetoChart;

    case CardTypesEnum.TensaoDeLinha:
      return ChildrenTypeEnum.TextCard;

    case CardTypesEnum.Tracker:
      return ChildrenTypeEnum.TrackerChart;

    case CardTypesEnum.Heatmap:
      return ChildrenTypeEnum.HeatmapChart;

    case CardTypesEnum.PotenciaAtiva:
      return ChildrenTypeEnum.TextCard;
    case CardTypesEnum.EnergiaAcumuladaMWh:
      return ChildrenTypeEnum.TextCard;
    default:
      return ChildrenTypeEnum.SunburstChart;
  }
}
export function getDefaulLayoutsByCardType(type: CardTypesEnum) {
  switch (type) {
    case CardTypesEnum.PRRealizado:
      return defaultLayoutPRRealizado;
    case CardTypesEnum.PerformanceRatio:
      return defaultLayoutPerformanceRatio;
    case CardTypesEnum.EnergiaGerada:
      return defaultLayoutEnergiaGerada;
    case CardTypesEnum.ValorGerado:
      return defaultLayoutValorGerado;
    case CardTypesEnum.Disponibilidade:
      return defaultLayoutDisponibilidade;
    case CardTypesEnum.Ambiente:
      return defaultLayoutAmbiente;
    case CardTypesEnum.EvolucaoGeracao:
      return defaultLayoutEvolucaoGeracao;
    case CardTypesEnum.GeracaoPlanta:
      return defaultLayoutGeracaoPlanta;
    case CardTypesEnum.EnergiaAcumulada:
      return defaultLayoutEnergiaAcumulada;
    case CardTypesEnum.DiagramaPerdas:
      return defaultLayoutDiagramaPerdas;
    case CardTypesEnum.EnergiaAcumEnergiaCert:
      return defaultLayoutEnergiaAcumEnergiaCert;
    case CardTypesEnum.Produtividade:
      return defaultLayoutProdutividade;
    case CardTypesEnum.Pareto:
      return defaultLayoutPareto;
    case CardTypesEnum.TensaoDeLinha:
      return defaultLayoutTensaoDeLinha;
    case CardTypesEnum.Tracker:
      return defaultLayoutTracker;
    case CardTypesEnum.Heatmap:
      return defaultLayoutHeatmap;
    case CardTypesEnum.PotenciaAtiva:
      return defaultLayoutPotenciaAtiva;
    case CardTypesEnum.EnergiaAcumuladaMWh:
      return defaultLayoutEnergiaAcumuladaMWh;
    default:
      return defaultLayoutPRRealizado;
  }
}
export function getDefaultPropsByCardType(type: CardTypesEnum) {
  switch (type) {
    case CardTypesEnum.PRRealizado:
      return prRealizadoContentProps;
    case CardTypesEnum.PerformanceRatio:
      return performanceRatioContentProps;
    case CardTypesEnum.EnergiaGerada:
      return energiaGeradaContentProps;
    case CardTypesEnum.ValorGerado:
      return valorGeradoContentProps;
    case CardTypesEnum.Disponibilidade:
      return disponibilidadeContentProps;
    case CardTypesEnum.Ambiente:
      return weatherInfoProps;
    case CardTypesEnum.EvolucaoGeracao:
      return evolutionChartProps;
    case CardTypesEnum.GeracaoPlanta:
      return sunburstChartProps;
    case CardTypesEnum.EnergiaAcumulada:
      return accumulatedEnergyProps;
    case CardTypesEnum.DiagramaPerdas:
      return lossDiagramProps;
    case CardTypesEnum.EnergiaAcumEnergiaCert:
      return accumulatedCertifiedEnergyProps;
    case CardTypesEnum.Produtividade:
      return productivityProps;
    case CardTypesEnum.Pareto:
      return paretoChartProps;
    case CardTypesEnum.TensaoDeLinha:
      return tensaoDeLinhaContentProps;
    case CardTypesEnum.Tracker:
      return trackerChartProps;
    case CardTypesEnum.Heatmap:
      return heatmapChartProps;
    case CardTypesEnum.PotenciaAtiva:
      return potenciaAtivaContentProps;
    case CardTypesEnum.EnergiaAcumuladaMWh:
      return energiaAcumuladaMWhContentProps;
    default:
      return sunburstChartProps;
  }
}
export function getLayoutsByCardTypeAndId(cardId: string, type: CardTypesEnum) {
  const layout = getDefaulLayoutsByCardType(type);
  const layouts = {
    lg: { ...layout.lg, cardId: cardId },
    md: { ...layout.md, cardId: cardId },
    sm: { ...layout.sm, cardId: cardId },
    xs: { ...layout.xs, cardId: cardId },
    xxs: { ...layout.xxs, cardId: cardId },
  };
  return layouts;
}
export function cardInfoToCardInfoIdentifiers(cardInfo: CardInfo) {
  return {
    id: cardInfo.id,
    type: cardInfo.type,
  };
}
export function cardInfoIdentifiersToCardInfo(
  cardInfoIdentifiers: CardInfoIdentifiers,
  props: CardChildrenProps
): CardInfo {
  const childrenType = getChildrenTypeByCardEnum(cardInfoIdentifiers.type);
  return {
    id: cardInfoIdentifiers.id,
    type: cardInfoIdentifiers.type,
    childrenProps: props,
    childrenType: childrenType,
  };
}
export function getUpdatedLayoutsAndCardId(
  layoutsConfig: ItemLayoutsConfig,
  type: CardTypesEnum
): { updatedLayouts: ItemLayoutsConfig; cardId: string } {
  const cardId = getNextCardId(type, layoutsConfig);
  const defaultCardLayout = getLayoutsByCardTypeAndId(cardId, type);
  const newLayout = {
    lg: { ...defaultCardLayout.lg, x: 0, y: 0 },
    md: { ...defaultCardLayout.md, x: 0, y: 0 },
    sm: { ...defaultCardLayout.sm, x: 0, y: 0 },
    xs: { ...defaultCardLayout.xs, x: 0, y: 0 },
    xxs: { ...defaultCardLayout.xxs, x: 0, y: 0 },
  };
  const filteredOldLgLayouts = layoutsConfig.layouts.lg?.filter(
    (layout) => layout.cardId !== cardId
  );
  const filteredOldMdLayouts = layoutsConfig.layouts.md?.filter(
    (layout) => layout.cardId !== cardId
  );
  const filteredOldSmLayouts = layoutsConfig.layouts.sm?.filter(
    (layout) => layout.cardId !== cardId
  );
  const filteredOldXsLayouts = layoutsConfig.layouts.xs?.filter(
    (layout) => layout.cardId !== cardId
  );
  const filteredOldXxsLayouts = layoutsConfig.layouts.xxs?.filter(
    (layout) => layout.cardId !== cardId
  );
  const newLgLayouts = filteredOldLgLayouts
    ? [...filteredOldLgLayouts, newLayout.lg]
    : [newLayout.lg];
  const newMdLayouts = filteredOldMdLayouts
    ? [...filteredOldMdLayouts, newLayout.md]
    : [newLayout.md];
  const newSmLayouts = filteredOldSmLayouts
    ? [...filteredOldSmLayouts, newLayout.sm]
    : [newLayout.sm];
  const newXsLayouts = filteredOldXsLayouts
    ? [...filteredOldXsLayouts, newLayout.xs]
    : [newLayout.xs];
  const newXxsLayouts = filteredOldXxsLayouts
    ? [...filteredOldXxsLayouts, newLayout.xxs]
    : [newLayout.xxs];
  const newLayouts = {
    ...layoutsConfig,
    layouts: {
      lg: newLgLayouts,
      md: newMdLayouts,
      sm: newSmLayouts,
      xs: newXsLayouts,
      xxs: newXxsLayouts,
    },
  };

  return { updatedLayouts: newLayouts, cardId };
}
export function getNextCardId(
  type: number,
  layoutsConfig: ItemLayoutsConfig
): string {
  const prRealizadoPrefix = "PrRealizado-";
  const performanceRatioPrefix = "PerformanceRatio-";
  const energiaGeradaPrefix = "EnergiaGerada-";
  const valorGeradoPrefix = "ValorGerado-";
  const disponibilidadePrefix = "Disponibilidade-";
  const ambientePrefix = "Ambiente-";
  const evolucaoGeracaoPrefix = "EvolucaoGeracao-";
  const geracaoPlantaPrefix = "GeracaoPlanta-";
  const energiaAcumuladaPrefix = "EnergiaAcumulada-";
  const diagramaPerdasPrefix = "DiagramaPerdas-";
  const energiaAcumEnergiaCertPrefix = "EnergiaAcumEnergiaCert-";
  const produtividadePrefix = "Produtividade-";
  const paretoPrefix = "Pareto-";
  const tensaoDeLinhaPrefix = "TensaoDeLinha-";
  const trackerPrefix = "Tracker-";
  const heatmapPrefix = "Heatmap-";
  const potenciaAtivaPrefix = "PotenciaAtiva-";
  const energiaAcumuladaMWhPrefix = "EnergiaAcumuladaMWh-";

  switch (type) {
    case CardTypesEnum.PRRealizado:
      return `${prRealizadoPrefix}${getNextCardIdNumber(
        layoutsConfig,
        prRealizadoPrefix
      )}`;
    case CardTypesEnum.PerformanceRatio:
      return `${performanceRatioPrefix}${getNextCardIdNumber(
        layoutsConfig,
        performanceRatioPrefix
      )}`;
    case CardTypesEnum.EnergiaGerada:
      return `${energiaGeradaPrefix}${getNextCardIdNumber(
        layoutsConfig,
        energiaGeradaPrefix
      )}`;
    case CardTypesEnum.ValorGerado:
      return `${valorGeradoPrefix}${getNextCardIdNumber(
        layoutsConfig,
        valorGeradoPrefix
      )}`;
    case CardTypesEnum.Disponibilidade:
      return `${disponibilidadePrefix}${getNextCardIdNumber(
        layoutsConfig,
        disponibilidadePrefix
      )}`;
    case CardTypesEnum.Ambiente:
      return `${ambientePrefix}${getNextCardIdNumber(
        layoutsConfig,
        ambientePrefix
      )}`;
    case CardTypesEnum.EvolucaoGeracao:
      return `${evolucaoGeracaoPrefix}${getNextCardIdNumber(
        layoutsConfig,
        evolucaoGeracaoPrefix
      )}`;
    case CardTypesEnum.GeracaoPlanta:
      return `${geracaoPlantaPrefix}${getNextCardIdNumber(
        layoutsConfig,
        geracaoPlantaPrefix
      )}`;
    case CardTypesEnum.EnergiaAcumulada:
      return `${energiaAcumuladaPrefix}${getNextCardIdNumber(
        layoutsConfig,
        energiaAcumuladaPrefix
      )}`;
    case CardTypesEnum.DiagramaPerdas:
      return `${diagramaPerdasPrefix}${getNextCardIdNumber(
        layoutsConfig,
        diagramaPerdasPrefix
      )}`;
    case CardTypesEnum.EnergiaAcumEnergiaCert:
      return `${energiaAcumEnergiaCertPrefix}${getNextCardIdNumber(
        layoutsConfig,
        energiaAcumEnergiaCertPrefix
      )}`;
    case CardTypesEnum.Produtividade:
      return `${produtividadePrefix}${getNextCardIdNumber(
        layoutsConfig,
        produtividadePrefix
      )}`;
    case CardTypesEnum.Pareto:
      return `${paretoPrefix}${getNextCardIdNumber(
        layoutsConfig,
        paretoPrefix
      )}`;
    case CardTypesEnum.TensaoDeLinha:
      return `${tensaoDeLinhaPrefix}${getNextCardIdNumber(
        layoutsConfig,
        tensaoDeLinhaPrefix
      )}`;
    case CardTypesEnum.Tracker:
      return `${trackerPrefix}${getNextCardIdNumber(
        layoutsConfig,
        trackerPrefix
      )}`;
    case CardTypesEnum.Heatmap:
      return `${heatmapPrefix}${getNextCardIdNumber(
        layoutsConfig,
        heatmapPrefix
      )}`;
    case CardTypesEnum.PotenciaAtiva:
      return `${potenciaAtivaPrefix}${getNextCardIdNumber(
        layoutsConfig,
        potenciaAtivaPrefix
      )}`;
    case CardTypesEnum.EnergiaAcumuladaMWh:
      return `${energiaAcumuladaMWhPrefix}${getNextCardIdNumber(
        layoutsConfig,
        energiaAcumuladaMWhPrefix
      )}`;
    default:
      return `${geracaoPlantaPrefix}${getNextCardIdNumber(
        layoutsConfig,
        prRealizadoPrefix
      )}`;
  }
}
function getNextCardIdNumber(
  layoutsConfig: ItemLayoutsConfig,
  prefix: string
): number {
  const cardsIds = layoutsConfig.layouts.lg
    ?.filter((layout) => layout.cardId.includes(prefix))
    .map((layout) => removeCardIdPrefix(layout.cardId, prefix));
  const lastId = cardsIds?.reduce((acc, id) => {
    return Number(id) > acc ? Number(id) : acc;
  }, 0);
  return lastId ? lastId + 1 : 1;
}
function removeCardIdPrefix(cardId: string, prefix: string) {
  return cardId.replace(prefix, "");
}

export function getDefaultCardsConfig(hasTrackers = true): CardInfo[] {
  const defaultCardsConfig: CardInfo[] = [
    {
      id: prRealizadoCardId,
      childrenType: ChildrenTypeEnum.TextCard,
      childrenProps: prRealizadoContentProps,
      type: CardTypesEnum.PRRealizado,
    },
    {
      id: performanceRatioCardId,
      childrenType: ChildrenTypeEnum.TextCard,
      childrenProps: performanceRatioContentProps,
      type: CardTypesEnum.PerformanceRatio,
    },
    {
      id: energiaGeradaCardId,
      childrenType: ChildrenTypeEnum.TextCard,
      childrenProps: energiaGeradaContentProps,
      type: CardTypesEnum.EnergiaGerada,
    },
    {
      id: valorGeradoCardId,
      childrenType: ChildrenTypeEnum.TextCard,
      childrenProps: valorGeradoContentProps,
      type: CardTypesEnum.ValorGerado,
    },
    {
      id: disponibilidadeCardId,
      childrenType: ChildrenTypeEnum.TextCard,
      childrenProps: disponibilidadeContentProps,
      type: CardTypesEnum.Disponibilidade,
    },
    {
      id: wheaterCardId,
      childrenType: ChildrenTypeEnum.WeatherCard,
      childrenProps: weatherInfoProps,
      type: 6,
    },
    {
      id: evolutionChartCardId,
      childrenType: ChildrenTypeEnum.EvolutionChart,
      childrenProps: evolutionChartProps,
      type: 7,
    },
    {
      id: sunburstCardId,
      childrenType: ChildrenTypeEnum.SunburstChart,
      childrenProps: sunburstChartProps,
      type: 8,
    },
    {
      id: accumulatedEnergyCardId,
      childrenType: ChildrenTypeEnum.AccumulatedEnergyChart,
      childrenProps: accumulatedEnergyProps,
      type: 9,
    },
    {
      id: lossDiagramCardId,
      childrenType: ChildrenTypeEnum.LossDiagramChart,
      childrenProps: lossDiagramProps,
      type: 10,
    },
    {
      id: accumulatedCertifiedEnergyCardId,
      childrenType: ChildrenTypeEnum.AccumulatedCertifiedEnergyChart,
      childrenProps: accumulatedCertifiedEnergyProps,
      type: 11,
    },
    {
      id: productivityCardId,
      childrenType: ChildrenTypeEnum.ProductivityChart,
      childrenProps: productivityProps,
      type: 12,
    },
    {
      id: paretoChartCardId,
      childrenType: ChildrenTypeEnum.ParetoChart,
      childrenProps: paretoChartProps,
      type: 15,
    },
    {
      id: TensaoDeLinhaCardId,
      childrenType: ChildrenTypeEnum.TextCard,
      childrenProps: tensaoDeLinhaContentProps,
      type: CardTypesEnum.TensaoDeLinha,
    },
    {
      id: trackerChartCardId,
      childrenType: ChildrenTypeEnum.TrackerChart,
      childrenProps: trackerChartProps,
      type: CardTypesEnum.Tracker,
    },
    {
      id: heatmapChartCardId,
      childrenType: ChildrenTypeEnum.HeatmapChart,
      childrenProps: heatmapChartProps,
      type: CardTypesEnum.Heatmap,
    },
    {
      id: potenciaAtivaCardId,
      childrenType: ChildrenTypeEnum.TextCard,
      childrenProps: potenciaAtivaContentProps,
      type: CardTypesEnum.PotenciaAtiva,
    },
    {
      id: energiaAcumuladaMWhCardId,
      childrenType: ChildrenTypeEnum.TextCard,
      childrenProps: energiaAcumuladaMWhContentProps,
      type: CardTypesEnum.EnergiaAcumuladaMWh,
    },
  ];
  return hasTrackers
    ? defaultCardsConfig
    : filterTrackerFromCardsConfig(defaultCardsConfig);
}

export function getDefaultLayouts(hasTrackers = true): ItemLayoutsConfig {
  return hasTrackers ? defaultLayouts : filterTrackerFromLayouts(defaultLayouts);
}

export function getNewCardConfig(
  type: CardTypesEnum,
  cardId: string,
  cardsDisplayableProps: CardsDisplayableProps,
  props?: CardChildrenProps
): CardInfo {
  switch (type) {
    case CardTypesEnum.PRRealizado:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.TextCard,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            prRealizadoContentProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.PerformanceRatio:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.TextCard,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            performanceRatioContentProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.EnergiaGerada:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.TextCard,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            energiaGeradaContentProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.ValorGerado:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.TextCard,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            valorGeradoContentProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.Disponibilidade:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.TextCard,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            disponibilidadeContentProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.Ambiente:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.WeatherCard,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            weatherInfoProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.EvolucaoGeracao:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.EvolutionChart,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            evolutionChartProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.GeracaoPlanta:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.SunburstChart,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            sunburstChartProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.EnergiaAcumulada:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.AccumulatedEnergyChart,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            accumulatedEnergyProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.DiagramaPerdas:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.LossDiagramChart,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            lossDiagramProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.EnergiaAcumEnergiaCert:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.AccumulatedCertifiedEnergyChart,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            accumulatedCertifiedEnergyProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.Produtividade:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.ProductivityChart,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            productivityProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.Pareto:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.ParetoChart,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            paretoChartProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.TensaoDeLinha:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.TextCard,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            tensaoDeLinhaContentProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.Tracker:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.TrackerChart,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            trackerChartProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.Heatmap:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.HeatmapChart,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            heatmapChartProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.PotenciaAtiva:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.TextCard,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            potenciaAtivaContentProps,
            cardId
          ),
        type: type,
      };
    case CardTypesEnum.EnergiaAcumuladaMWh:
      return {
        id: cardId,
        childrenType: ChildrenTypeEnum.TextCard,
        childrenProps:
          props ??
          getCardPropsByEnumAndDisplayableProps(
            type,
            cardsDisplayableProps,
            energiaAcumuladaMWhContentProps,
            cardId
          ),
        type: type,
      };
  }
}

export function getCardPropsByEnumAndDisplayableProps(
  type: CardTypesEnum,
  cardsDisplayableProps: CardsDisplayableProps,
  props: CardChildrenProps,
  cardId?: string
): CardChildrenProps {
  const childrenProps = {
    ...props,
    cardId: cardId ?? props.cardId,
  };
  switch (type) {
    case CardTypesEnum.PRRealizado: {
      if (checkObjectType(ChildrenTypeEnum.TextCard, childrenProps)) {
        const correctProps = childrenProps as TextCardContentProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.prRealizado.title
            ? prRealizadoContentProps.title
            : "",
          value: cardsDisplayableProps.prRealizado.value
            ? prRealizadoContentProps.value
            : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.PerformanceRatio: {
      if (checkObjectType(ChildrenTypeEnum.TextCard, childrenProps)) {
        const correctProps = childrenProps as TextCardContentProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.performanceRatio.title
            ? performanceRatioContentProps.title
            : "",
          value: cardsDisplayableProps.performanceRatio.value
            ? performanceRatioContentProps.value
            : "",
          secondaryData: getDisplayableSecondaryData(
            performanceRatioContentProps.secondaryData,
            cardsDisplayableProps.performanceRatio.idealEnergy
          ),
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.EnergiaGerada: {
      if (checkObjectType(ChildrenTypeEnum.TextCard, childrenProps)) {
        const correctProps = childrenProps as TextCardContentProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.energiaGerada.title
            ? energiaGeradaContentProps.title
            : "",
          value: cardsDisplayableProps.energiaGerada.value
            ? energiaGeradaContentProps.value
            : "",
          secondaryData: getDisplayableSecondaryData(
            correctProps.secondaryData,
            cardsDisplayableProps.energiaGerada.ideal,
            cardsDisplayableProps.energiaGerada.percent
          ),
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.ValorGerado: {
      if (checkObjectType(ChildrenTypeEnum.TextCard, childrenProps)) {
        const correctProps = childrenProps as TextCardContentProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.valorGerado.title
            ? valorGeradoContentProps.title
            : "",
          value: cardsDisplayableProps.valorGerado.value
            ? valorGeradoContentProps.value
            : "",
          secondaryData: getDisplayableSecondaryData(
            valorGeradoContentProps.secondaryData,
            cardsDisplayableProps.valorGerado.ideal,
            cardsDisplayableProps.valorGerado.percent
          ),
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.Disponibilidade: {
      if (checkObjectType(ChildrenTypeEnum.TextCard, childrenProps)) {
        const correctProps = childrenProps as TextCardContentProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.disponibilidade.title
            ? disponibilidadeContentProps.title
            : "",
          value: cardsDisplayableProps.disponibilidade.value
            ? disponibilidadeContentProps.value
            : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.Ambiente: {
      if (checkObjectType(ChildrenTypeEnum.WeatherCard, childrenProps)) {
        const correctProps = childrenProps as WeatherInfoCardContentProps;
        return {
          ...correctProps,
          weather: cardsDisplayableProps.ambiente.wearher
            ? weatherInfoProps.weather
            : {},
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.EvolucaoGeracao: {
      if (checkObjectType(ChildrenTypeEnum.EvolutionChart, childrenProps)) {
        const correctProps = childrenProps as EvolutionChartProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.evolucaoGeracao.title
            ? evolutionChartProps.title
            : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.GeracaoPlanta: {
      if (checkObjectType(ChildrenTypeEnum.SunburstChart, childrenProps)) {
        const correctProps = childrenProps as SunburstChartProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.geracaoPlanta.title
            ? sunburstChartProps.title
            : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.EnergiaAcumulada: {
      if (
        checkObjectType(ChildrenTypeEnum.AccumulatedEnergyChart, childrenProps)
      ) {
        const correctProps = childrenProps as AccumulatedEnergyProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.energiaAcumulada.title
            ? accumulatedEnergyProps.title
            : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.DiagramaPerdas: {
      if (checkObjectType(ChildrenTypeEnum.LossDiagramChart, childrenProps)) {
        const correctProps = childrenProps as LossDiagramProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.diagramaPerdas.title
            ? lossDiagramProps.title
            : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.EnergiaAcumEnergiaCert: {
      if (
        checkObjectType(
          ChildrenTypeEnum.AccumulatedCertifiedEnergyChart,
          childrenProps
        )
      ) {
        const correctProps = childrenProps as AccumulatedCertifiedEnergyProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.energiaAcumEnergiaCert.title
            ? accumulatedCertifiedEnergyProps.title
            : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.Produtividade: {
      if (checkObjectType(ChildrenTypeEnum.ProductivityChart, childrenProps)) {
        const correctProps = childrenProps as ProductivityProps;
        return {
          ...correctProps,
          title: productivityProps.title ? productivityProps.title : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.Pareto: {
      if (checkObjectType(ChildrenTypeEnum.ParetoChart, childrenProps)) {
        const correctProps = childrenProps as ParetoChartProps;
        return {
          title: paretoChartProps.title ? paretoChartProps.title : "",
          ...correctProps,
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.TensaoDeLinha: {
      if (checkObjectType(ChildrenTypeEnum.TextCard, childrenProps)) {
        const correctProps = childrenProps as TextCardContentProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.tensaoDeLinha?.title
            ? tensaoDeLinhaContentProps.title
            : "",
          value: cardsDisplayableProps.tensaoDeLinha?.tensaoDeLinhakV
            ? tensaoDeLinhaContentProps.value
            : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.Tracker: {
      if (checkObjectType(ChildrenTypeEnum.TrackerChart, childrenProps)) {
        const correctProps = childrenProps as TrackerChartProps;
        return {
          ...correctProps,
          title: trackerChartProps.title ? trackerChartProps.title : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.Heatmap: {
      if (checkObjectType(ChildrenTypeEnum.HeatmapChart, childrenProps)) {
        const correctProps = childrenProps as HeatmapChartProps;
        return {
          ...correctProps,
          title: heatmapChartProps.title ? heatmapChartProps.title : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.PotenciaAtiva: {
      if (checkObjectType(ChildrenTypeEnum.TextCard, childrenProps)) {
        const correctProps = childrenProps as TextCardContentProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.potenciaAtiva.title
            ? potenciaAtivaContentProps.title
            : "",
          value: cardsDisplayableProps.potenciaAtiva.value
            ? potenciaAtivaContentProps.value
            : "",
        };
      } else {
        return childrenProps;
      }
    }
    case CardTypesEnum.EnergiaAcumuladaMWh: {
      if (checkObjectType(ChildrenTypeEnum.TextCard, childrenProps)) {
        const correctProps = childrenProps as TextCardContentProps;
        return {
          ...correctProps,
          title: cardsDisplayableProps.energiaAcumudalaMWh.title
            ? energiaAcumuladaMWhContentProps.title
            : "",
          value: cardsDisplayableProps.energiaAcumudalaMWh.value
            ? energiaAcumuladaMWhContentProps.value
            : "",
        };
      } else {
        return childrenProps;
      }
    }
  }
}
function getDisplayableSecondaryData(
  secondaryData:
    | {
      title?: string;
      value: string;
    }[]
    | undefined,
  showItem1: boolean,
  showItem2?: boolean
) {
  if (secondaryData === undefined) {
    return undefined;
  }
  if (showItem1 && showItem2) {
    if (secondaryData && secondaryData.length > 1) return secondaryData;
  } else if (showItem1) {
    if (secondaryData && secondaryData.length > 0) return [secondaryData[0]];
  } else if (showItem2) {
    if (secondaryData && secondaryData.length > 1) return [secondaryData[1]];
  } else {
    return undefined;
  }
}
export function getCardsInfoWithUpdatedProps(
  cardsInfo: CardInfo[],
  cardsDisplayableProps: CardsDisplayableProps
): CardInfo[] {
  return cardsInfo.map((card) => {
    return {
      ...card,
      childrenProps: getCardPropsByEnumAndDisplayableProps(
        card.type,
        cardsDisplayableProps,
        card.childrenProps
      ),
    };
  });
}
export function getHourAndMinutes(date: string) {
  const dateObject = new Date(date);
  const hour = String(dateObject.getHours()).padStart(2, "0");
  const minutes = String(dateObject.getMinutes()).padStart(2, "0");
  return `${hour}:${minutes}`;
}

/**
 * Data de calendário do backend (relógio de parede BRT), sem shift UTC→local.
 * `new Date('yyyy-MM-ddT00:00:00Z')` em BRT vira dia anterior (−3h) e quebrava o título do card.
 */
export function getYearDay(date: string) {
  const isoDateMatch = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDateMatch) {
    const [, year, month, day] = isoDateMatch;
    return `${Number(day)}/${Number(month)}/${year}`;
  }

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime()) || parsed.getFullYear() < 1970) {
    return "";
  }

  return parsed.toLocaleDateString("pt-BR", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  });
}
